import React from "react";

import { clamp } from "src/utils/clamp";

import "./progress_circle.scss";

/*
 * Types
 */

export interface ProgressCircleProps extends React.InputHTMLAttributes<HTMLInputElement> {
    // The server sends back a number between 0 and 1
    readonly percentage?: number;
    readonly totalCompleted?: number;
    readonly totalRequired?: number;
}

/*
 * Main
 */

export const ProgressCircle = (props: ProgressCircleProps): React.ReactElement => {
    const { children, percentage, totalCompleted, totalRequired, ...rest } = props;

    if (percentage === undefined && (totalCompleted === undefined || totalRequired === undefined)) {
        throw new Error("Either percentage or totalCompleted and totalRequired must be provided");
    }

    let percentageToDisplay = percentage;
    if (
        percentageToDisplay === undefined &&
        totalCompleted !== undefined &&
        totalRequired !== undefined &&
        totalRequired > 0
    ) {
        percentageToDisplay = totalCompleted / totalRequired;
    } else if (totalRequired !== undefined && totalRequired === 0) {
        percentageToDisplay = 0;
    }

    return (
        <div className="circle-progress-wrapper-outer">
            <div className={`circle-progress-wrapper percentage-${clamp(percentageToDisplay)}`} {...rest}>
                <svg viewBox="0 0 36 36">
                    <path
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        fill="none"
                        stroke="#C6C5C4"
                        strokeDasharray="100, 100"
                        strokeWidth="4"
                    />
                </svg>
                <svg viewBox="0 0 36 36">
                    <path
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        fill="none"
                        stroke="#91B839"
                        strokeDasharray={`${clamp(percentageToDisplay)}, 100`}
                        strokeWidth="4"
                    />
                </svg>

                <div className="inner-value">{`${clamp(percentageToDisplay)}`}%</div>
            </div>
            <div className="outer-progress-label">{children}</div>
            {totalRequired !== 0 && totalCompleted !== 0 && (
                <div className="outer-progress-count">
                    {totalCompleted}/{totalRequired}
                </div>
            )}
        </div>
    );
};
